export var wrapper = 'overflow-hidden bg-white';
export var optionsWrapper = function (index, checked, colour, selectedOptionBackgroundColor) {
    return " flex flex-row justify-start items-start mb-1 p-4 rounded-lg items-center ".concat(checked ? "bg-".concat(selectedOptionBackgroundColor) : 'bg-uiBg', " ").concat(checked ? "border border-".concat(colour) : 'border border-uiBg');
};
export var groupCircleStyle = function (checked, colour) {
    return "".concat(checked ? "bg-".concat(colour, " border-").concat(colour) : "border border-".concat(colour), " w-4 h-4 flex-shrink-0 rounded-full flex justify-center items-center mr-2 mt-1");
};
export var inner = 'h-1 w-1 bg-white rounded-full';
//# sourceMappingURL=radio-group.styles.js.map